import { RootState } from '@core/Store'

export const selectTippingSelections = (state: RootState) => state.tipping.selections
